import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
// import Cookies from 'js-cookie'
import VueMixin from './mixins/VueMixin'
import store from './store'
import routerBluepay from './router/bluepay/index.js'
import routerJtwallet from './router/jtwallet/index.js'
import directives from './directive/index'
import Vant from 'vant'
import { Locale } from 'vant'
import { languageMap } from '@/utils/maps'

import 'amfe-flexible'
import { Lazyload } from 'vant'

import '@/styles/variables.less'
import '@/styles/theme.less'
import 'vant/lib/index.css'
import 'vant/lib/index.less'
import '@/styles/index.less'
import '@/styles/fonts.css'
import '@/styles/reset-vant.less'
import '@/icon/iconfont.css'
import i18n from './locales'
import bus from './utils/bus'
import * as filters from './filters' // global filters
import ConstData from './constants/ConstData'
import commonFn from './utils/common'
import VueClipboard from 'vue-clipboard2'
import vueEsign from 'vue-esign'
import './styles/conmon.less'
// vue components
import CustomNavbar from '@/components/CustomNavbar.vue'

Vue.component('CustomNavbar', CustomNavbar)

const dsBridge = require('dsbridge')

import '@/permission' // permission control

import MuseUI from 'muse-ui'
import 'muse-ui/dist/muse-ui.css'
import VueLoadmore from 'vuejs-loadmore'
import permission from './directive/permission/index'
import { initSentry } from '@/utils/sentryConfig'
Vue.config.productionTip = false

// fastClick
// import FastClick from 'fastclick';
//
// FastClick.attach(document.body)

Vue.use(Vant, {
  i18n: (key, value) => i18n.t(key, value)
})

const lang = languageMap.get(localStorage.getItem('lang') || 'th')
Locale.use(lang.key, lang.value)
Vue.use(permission)
Vue.use(Lazyload)
Vue.use(directives)
Vue.mixin(VueMixin)
Vue.use(MuseUI)
Vue.use(VueClipboard)
Vue.use(vueEsign)
Vue.use(VueLoadmore, {
  lang: 'en-US'
})

let router
if (process.env.VUE_APP_PLATFORM === 'bluepay') {
  router = routerBluepay
}
if (process.env.VUE_APP_PLATFORM === 'jtwallet') {
  router = routerJtwallet
}
Vue.prototype.$dsBridge = dsBridge
Vue.prototype.$ConstData = ConstData
Vue.prototype.$commonFn = commonFn

Vue.prototype.$noScroll = function () {
  const mo = function (e) {
    e.preventDefault()
  }
  document.body.style.overflow = 'hidden'
  document.addEventListener('touchmove', mo, false) // 禁止页面滑动
}
const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.prototype.$canScroll = function () {
  const mo = function (e) {
    e.preventDefault()
  }
  document.body.style.overflow = ''
  document.removeEventListener('touchmove', mo, false)
}

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Object.defineProperty(Vue.prototype, '$bus', { value: bus.bus })

Vue.config.errorHandler = function (err, vm, info) {
  console.error(err)
  if (process.env.NODE_ENV !== 'development') {
    store.dispatch('app/submitLog', {
      message: 'err: ' + err.toString() + '; ' + 'vue-error-info: ' + info.toString(),
      level: 2
    })
  }
}
// 在全局错误处理中捕获ChunkLoadError
window.addEventListener('error', event => {
  if (event.message && event.message.includes('Loading chunk') && !event.error.handled) {
    event.error.handled = true
    window.location.reload() // 强制从服务器刷新
  }
})

if (process.env.NODE_ENV === 'production') {
  // 仅生产注入，避免影响本地开发体验
  import('./utils/antiDebug').then(({ default: antiDebug }) => {
    // 可按需保留引用：window.__stopAntiDebug = antiDebug;
  })
}

initSentry(Vue)

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  bus,
  render: h => h(App)
})
